module.exports = __webpack_public_path__ + "c_static/img/核对店铺名.e46c917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/核对店铺名.jpg
// module id = JUZ9
// module chunks = 33